// @internal
import './number-operations';

export function getTarget(originalTarget: EventTarget | null, check: (element: HTMLElement) => boolean): HTMLElement | null
{
	let target: EventTarget | null = originalTarget;

	while (target && (target instanceof HTMLElement) && !check(target))
	{
		target = target.parentElement;
	}

	if (target && (target instanceof HTMLElement) && check(target))
	{
		return target;
	}
	else
	{
		return null;
	}
}
